import ForgotPassword from "@/components/auth/forgot-password";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import React from "react";

const ForgotPasswordPage: React.FC = () => {
  return <ForgotPassword />;
};

export default withErrorBoundary({ component: "ForgotPasswordPage" })(ForgotPasswordPage);
